import { Contact } from '@/api/apis/facilities';
import { getContactFullName } from '@/utils/helpers';

const UNNAMED_CONTACT_LABEL = 'Unnamed Contact';

export type ContactSelectItem = { value: string; name: string };

export function mapContactsToSelectItems(list?: Contact[]): ContactSelectItem[] {
  return (list ?? [])
    .map(({ id, firstName, lastName, email, primaryPhone, secondaryPhone }) => {
      const fullName = getContactFullName(firstName, lastName);
      const hasRealName = fullName && fullName !== UNNAMED_CONTACT_LABEL;
      const hasOtherInfo = !!(email || primaryPhone || secondaryPhone);

      if (hasRealName) {
        return { value: id, name: fullName };
      }
      if (hasOtherInfo) {
        return { value: id, name: UNNAMED_CONTACT_LABEL };
      }
      return null;
    })
    .filter((item): item is ContactSelectItem => item !== null);
}
